import { Injectable } from '@angular/core';
import {FormatOptions} from './interfaces/format-service.interface';
import * as moment from 'jalali-moment';

@Injectable()
export class DateFormatService {

  constructor() { }

  formatData(data: string, formatOptions: Partial<FormatOptions>): string {
    const labelParts = data.split('T');
    if (labelParts.length !== 2) {
      return data;
    }
    labelParts[0] = labelParts[0].replaceAll('-','/');
    if(formatOptions.calenderType === 'Shamsi'){
      
      const moment = require('jalali-moment')
      const momentDate = moment(data)?.locale('fa')
      if(!momentDate.isValid()) {
        labelParts[0] = this.convertToJalali(labelParts[0]);
      }
    }
    if (formatOptions.dateTimeFormatType === 'Format1'){
      return this.dateFormat1(formatOptions, labelParts);
    }else if(formatOptions.dateTimeFormatType === 'Format2'){
      return this.dateFormat2(formatOptions, labelParts);
    }else if(formatOptions.dateTimeFormatType === 'Format3'){
      return this.dateFormat3(formatOptions, labelParts);
    }else if(formatOptions.dateTimeFormatType === 'Format4') {
      return this.dateFormat4(formatOptions, labelParts);
    }else if(formatOptions.dateTimeFormatType === 'Format5') {
      return this.dateFormat5(formatOptions, labelParts);
    }else if(formatOptions.dateTimeFormatType === 'Format6') {
      return this.dateFormat6(formatOptions, labelParts);
    }else if(formatOptions.dateTimeFormatType === 'Format7') {
      return this.dateFormat7(formatOptions, labelParts);
    }else if(formatOptions.dateTimeFormatType === 'Format8') {
      return this.dateFormat8(formatOptions, labelParts);
    }
  }

  private dateFormat1(formatOptions: Partial<FormatOptions>, labelParts: any): string {
    if(formatOptions.formatType === 'Date') {
      labelParts[0] = labelParts[0].replaceAll('/','-');
    }
    labelParts[1] = labelParts[1].slice(0,5);
    const numbers = this.numberFormat(labelParts[1].split(':'));
    if(Number(numbers[0]) > 12){
      labelParts[1] = numbers.join(':') + (formatOptions.calenderType === 'Miladi' ? ' pm' : ' بظ');
    } else {
      labelParts[1] = numbers.join(':') + (formatOptions.calenderType === 'Miladi' ? ' am': ' قظ');
    }
    return (formatOptions.formatType !== 'Time' ? labelParts[0] : '') +
        (formatOptions.formatType === 'DateTime' ? ' ' : '') +
        (formatOptions.formatType !== 'Date' ? labelParts[1] : '');
  }

  private dateFormat2(formatOptions: Partial<FormatOptions>, labelParts: any): string {
    if(formatOptions.formatType !== 'Date') {
      labelParts[1] = labelParts[1].slice(0,5);
    }
    if(formatOptions.formatType === 'Date') {
      const date = this.numberFormat(labelParts[0].split('/'));
      labelParts[0] = date.slice(1,3).join('/');
    }
    return (formatOptions.formatType !== 'Time' ? labelParts[0] : '') +
        (formatOptions.formatType==='DateTime' ? ' ' : '') +
        (formatOptions.formatType !== 'Date' ? labelParts[1] : '');
  }

  private dateFormat3(formatOptions: Partial<FormatOptions>, labelParts: any): string {
    if(formatOptions.formatType === 'Date') {
      const date  = this.numberFormat(labelParts[0].split('/'));
      date[0] = date[0].substring(2,4);
      labelParts[0] = `${date[2]}/${date[1]}/${date[0]}`;
    }
    return (formatOptions.formatType === 'Date' ? labelParts[0] : '') +
        (formatOptions.formatType === 'Time' ? labelParts[1] : '');
  }

  private dateFormat4(formatOptions: Partial<FormatOptions>, labelParts: any): string {
    const numbers = this.numberFormat(labelParts[1].split(':'));
    if(formatOptions.formatType === 'Time') {
      if(Number(numbers[0]) > 12){
        labelParts[1] = numbers.join(':') + (formatOptions.calenderType === 'Miladi' ? ' pm' : ' بظ');
      } else {
        labelParts[1] = numbers.join(':') + (formatOptions.calenderType === 'Miladi' ? ' am': ' قظ');
      }
    }
    if(formatOptions.formatType === 'Date') {
      const date  = labelParts[0].split('/');
      date[0] = date[0].substring(2,4);
      labelParts[0] = `${date[2]}/${date[1]}/${date[0]}`;
    }
    return (formatOptions.formatType === 'Date' ? labelParts[0] : '') +
        (formatOptions.formatType === 'Time' ? labelParts[1] : '');
  }

  private dateFormat5(formatOptions: Partial<FormatOptions>, labelParts: any): string {
    const dates = labelParts[0].split('/');
    labelParts[0] = formatOptions.calenderType === 'Miladi' ?
        this.getGeorgianMonth(Number(dates[1])) + '-' + dates[2] :
        this.getJalaliMonth(Number(dates[1])) + '-' + dates[2];
    return formatOptions.formatType === 'Date' ? labelParts[0] : '';
  }

  private dateFormat6(formatOptions: Partial<FormatOptions>, labelParts: any): string {
    const dates = labelParts[0].split('/');
    labelParts[0] = formatOptions.calenderType === 'Miladi' ?
        this.getGeorgianMonth(Number(dates[1])) + '-' + dates[0].substring(2,4) + '-' + dates[2] :
        this.getJalaliMonth(Number(dates[1])) + '-' + dates[0].substring(2,4) + '-' + dates[2];
    return formatOptions.formatType === 'Date' ? labelParts[0] : '';
  }

  private dateFormat7(formatOptions: Partial<FormatOptions>, labelParts: any): string {
    const dates = labelParts[0].split('/');
    labelParts[0] = formatOptions.calenderType === 'Miladi' ?
        this.getGeorgianMonth(Number(dates[1])) + '-' + dates[0].substring(2, 4) :
        this.getJalaliMonth(Number(dates[1])) + '-' + dates[0].substring(2, 4);
    return formatOptions.formatType === 'Date' ? labelParts[0] : '';
  }

  private dateFormat8(formatOptions: Partial<FormatOptions>, labelParts: any): string {
    const dates = labelParts[0].split('/');
    labelParts[0] = formatOptions.calenderType === 'Miladi' ?
        this.getGeorgianMonth(Number(dates[1])) + ' ' + dates[2] + ',' + dates[0] :
        this.getJalaliMonth(Number(dates[1])) + ' ' + dates[0] + '٬' + dates[2];
    return formatOptions.formatType === 'Date' ? labelParts[0] : '';
  }


  private getJalaliMonth(month: number): string {
    const months = ['فروردین','اردیبهشت','خرداد','تیر','مرداد','شهریور','مهر','آبان','آذر','دی','بهمن','اسفند'];
    return months[month - 1];
  }

  private getGeorgianMonth(month: number): string {
    const jalaliMonths =
        ['January','February','March','April','May','June','July','August','September','October','November','December'];
    return jalaliMonths[month - 1];
  }

  private convertToJalali(date: string): string{
    try {
      return moment(date,'YYYY/M/D').locale('fa').format('YYYY/MM/DD');
    }catch (e) {
      return date;
    }
  }

  private numberFormat(values: string[]): string[] {
    values.forEach((value, index, self) => {
      self[index] = Number(value).toString();
    });
    return values;
  }
}
